<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="版本">
              <global-select
                :value.sync="queryParams.version"
                selectType="selectSearch"
                requestApi="/scp/scpMpsPlans/listMpsPlanVersion"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="version"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <global-select
                :value.sync="queryParams.status"
                selectType="selectFilter"
                :selectData="monthToDayTypeOpinions"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                searchParam="status"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="周计划版本">
              <a-input v-model="queryParams.weekVersionName" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary" v-hasPermi="['scp:scpMpsPlans:findPage']">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="$refs.startWeeklyBalancing.show()" type="primary" v-hasPermi="['scp:scpMpsPlans:start']">新建MPS计划</a-button>
      <a-button @click="handleRunWeeklyBalancing" v-hasPermi="['scp:scpMpsPlans:run']">启动供应商分配</a-button>
      <a-button @click="handleMpsPlansSmooth" v-hasPermi="['scp:scpMpsPlans:week']">启动周/日平滑</a-button>
      <a-button @click="handleStopCalculationAlert" v-hasPermi="['scp:scpMpsPlans:stop']">强制终止</a-button>

    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          :tableProps="tableProps"
          :scroll="{ fixScreen: true, x: 1300 }"
          @selectedRowChange="selectedRowChange"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.MPS_WORK_DESK_LIST, // 表格方案配置唯一值
              }"
        >
          <span slot="version" slot-scope="{ record }">
            <a-button type="link" :disabled="!$hasPermi(['scp:scpMpsPlans:detail'])" @click="handleGoDetail(record)" class="ml10">{{ record.version }}</a-button>
          </span>
          <template slot="formatTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
          </template>
          <!-- 操作 -->
          <span slot="operation" slot-scope="{ record }">
            <a class="ml10" @click="handleDel(record)" v-hasPermi="['scp:scpMpsPlans:delete']">删除</a>
            <a class="ml10" v-if="record.status !== '已关闭' && record.status !== '已发布'" @click="handleClose(record)" v-hasPermi="['scp:scpMpsPlans:close']">关闭</a>
            <a class="ml10" v-if="record.status === '已完成'" @click="handlePublish(record)" v-hasPermi="['scp:scpMpsPlans:publish']">发布</a>
          </span>
        </ls-api-table>
        <StartWeeklyBalancing @handle-success="handleOk" ref="startWeeklyBalancing"></StartWeeklyBalancing>
      </div>
    </template>

  </ls-table-layout>
</template>

        <script>
    import { generateLsTableResData } from '@/utils/util.js'
     import { ApiUpdateSopMonthPlan, ApiSendSopMonthPlan } from '@/api/scp/month-plan/month-plan.js'
     import moment from 'moment';
     import { ApiScpMpsPlansList, ApiDeleteScpMpsPlans, ApiStopScpMpsPlans, ApiRunMpsProcess, ApiRunMpsPlansSmooth, ApiCloseScpMpsPlans, ApiPublishScpMpsPlans } from '@/api/mps/basic-data/mps-option.js'
     import StartWeeklyBalancing from './components/StartWeeklyBalancing';
    export default {
      // eslint-disable-next-line
      name: 'Mps-work-desk',
      components: {
        StartWeeklyBalancing
      },
      computed: {
      // 其他计算属性
      // ...
      formattedParams () {
        return {
          monthStart: moment(this.currentPeriod).format("YYYYMM")
          // monthEnd: moment(this.baseInfo.forecastPeriodTo).format("YYYYMM")
        };
      }
    },
      data () {
        return {
          monthToDayTypeOpinions: [],
          moment: moment, // 在 data 中创建 moment 实例
          currentPeriod: '',
          isEdit: false,
          currentId: "",
          lookUpCode: '',
          // 表格多选
          selectedRowKeys: [],
          selectedRows: [],
          // 表格配置
          tableProps: {
            requestApi: generateLsTableResData(ApiScpMpsPlansList, true),
            pageCurrent: true
          },
          // 查询参数
          queryParams: {
            version: undefined,
            status: undefined,
            weekVersionName: undefined
          },
          baseUomFlagOptions: [
            {
              dictLabel: '是',
              dictValue: 'Y'
            },
            {
              dictLabel: '否',
              dictValue: 'N'
            }
          ],
          // 表格字段
          columns: [
            {
              title: '周计划版本',
              dataIndex: 'weekVersionName',
              ellipsis: true,
              width: 120,
              align: 'center'
            },
            {
              title: '版本',
              dataIndex: 'version',
              scopedSlots: { customRender: 'version' },
              ellipsis: true,
              width: 120,
              align: 'center'
            },
            {
              title: '版本说明',
              dataIndex: 'description',
              ellipsis: true,
              align: 'left',
              width: 220
            },
            {
              title: '产品属性',
              dataIndex: 'itemAttribute',
              align: 'center',
              width: 120
            },
            {
              title: '包含值',
              dataIndex: 'includeValues',
              align: 'center',
              ellipsis: true,
              width: 180
            },
            {
              title: '月度计划名称和版本',
              dataIndex: 'mpNameAndVersion',
              ellipsis: true,
              align: 'center',
              width: 180
            },
            {
              title: '状态',
              width: 120,
              dataIndex: 'status',
              ellipsis: true,
              align: 'center'
            },
            {
              title: '最后更新人',
              width: 120,
              dataIndex: 'updateName',
              align: 'center'
            },
            {
              title: '开始时间',
              width: 180,
              dataIndex: 'createTime',
              scopedSlots: { customRender: 'formatTime' },
              ellipsis: true,
              align: 'center'
            },
            {
              title: '最后更新日期',
              width: 180,
              dataIndex: 'updateTime',
              scopedSlots: { customRender: 'formatTime' },
              ellipsis: true,
              align: 'center'
            },
            {
              title: '操作',
              width: 150,
              stickyFixed: 'right',
              align: 'center',
              dataIndex: 'operation',
              scopedSlots: { customRender: 'operation' }
            }
          ]
        }
      },
      created () {
       // this.getLastSalesForecast()
     //  this.getLookUpCode('SOP_PROCESS_STATU')
     this.getLookupList('SCP_PROCESS_STATUS', 'monthToDayTypeOpinions')
      },
      mounted () {
        this.onSearch()
      },
      methods: {
            // 新增/修改框事件
      handleOk () {
        this.onSearch()
      },
      handleMpsPlansSmooth () {
                /** 检查只能选择一个 */
                if (this.selectedRows.length > 1) {
                  this.$message.error('计算选择项不能大于1')
                  return
                }
                if (this.selectedRows.length === 0) {
                  this.$message.error('请勾选其中一项')
                  return
                }
                if (['已关闭', '已发布'].indexOf(this.selectedRows[0].status) !== -1) {
                  this.$message.error('该状态不允许启动周/日平滑')
                  return;
                }
                const self = this
                this.$confirm({
                  title: '提示',
                  content: '你确定启动周平滑吗？',
                  okText: '确定',
                  okType: 'danger',
                  cancelText: '取消',
                  onOk () {
                    ApiRunMpsPlansSmooth(self.selectedRows[0].id).then(response => {
                      if (response.code === 200) {
                        self.$message.success('启动成功')
                        self.onSearch()
                      } else {
                        self.$message.error(response.msg)
                      }
                    })
                  },
                  onCancel () {
                  }
                });
      },

      handleRunWeeklyBalancing () {
                /** 检查只能选择一个 */
                if (this.selectedRows.length > 1) {
                  this.$message.error('计算选择项不能大于1')
                  return
                }
                if (this.selectedRows.length === 0) {
                  this.$message.error('请勾选其中一项')
                  return
                }
                if (['已关闭', '已发布'].indexOf(this.selectedRows[0].status) !== -1) {
                  this.$message.error('该状态不允许启动供应商分配')
                  return;
                }
                const self = this
                this.$confirm({
                  title: '提示',
                  content: '你确定启动周配平吗？',
                  okText: '确定',
                  okType: 'danger',
                  cancelText: '取消',
                  onOk () {
                    ApiRunMpsProcess(self.selectedRows[0].id).then(response => {
                      if (response.code === 200) {
                        self.$message.success('启动成功')
                        self.onSearch()
                      } else {
                        self.$message.error(response.msg)
                      }
                    })
                  },
                  onCancel () {
                  }
                });
      },
        handleStopCalculationAlert () {
                /** 检查只能选择一个 */
            if (this.selectedRows.length > 1) {
                  this.$message.error('停止计算选择项不能大于1')
                  return
                }
                if (this.selectedRows.length === 0) {
                  this.$message.error('请勾选其中一项')
                  return
                }
                if (['已关闭', '已发布'].indexOf(this.selectedRows[0].status) !== -1) {
                  this.$message.error('该状态不允许强制终止')
                  return;
                }
                const self = this
                this.$confirm({
                  title: '提示',
                  content: '你确定停止该记录吗？',
                  okText: '确定',
                  okType: 'danger',
                  cancelText: '取消',
                  onOk () {
                    self.handleStopCalculation()
                  },
                  onCancel () {
                  }
                });
        },
        handleStopCalculation () {
          ApiStopScpMpsPlans(this.selectedRows[0].id).then(response => {
            if (response.code === 200) {
              this.$message.success('停止成功')
            } else {
              this.$message.error(response.msg)
            }
          })
        },
          getLookUpCode (code) {
              const lookupQueryParams = {
                  lookupType: code,
                  current: 1,
                  pageSize: 100
              }
              this.getLookupListData(lookupQueryParams).then().then(response => {
              // this.lookUpCode[code] = response.rows
              this.$set(this.lookUpCode, code, response.rows)
              })
          },
        resetQuery () {
          this.queryParams = {
              monthPlanName: undefined,
              monthPlanVersion: undefined,
              status: undefined
          }
          this.onSearch()
        },
        handleGoCapacityLoad () {
          /** 检查只能选择一个 */
          if (this.selectedRows.length > 1) {
            this.$message.error('产能负荷的选择项不能大于1')
            return
          }
          if (this.selectedRows.length === 0) {
            this.$message.error('请勾选其中一项')
            return
          }
          this.$router.push({ path: `/monthly-plan/capacityLoadPage/${this.selectedRows[0].monthPlanName}/${this.selectedRows[0].monthPlanVersion}/${this.selectedRows[0].id}` })
        },
        handleGoDemand () {
                  /** 检查只能选择一个 */
                  if (this.selectedRows.length > 1) {
            this.$message.error('生产需求的选择项不能大于1')
            return
          }
          if (this.selectedRows.length === 0) {
            this.$message.error('请勾选其中一项')
            return
          }
          this.$router.push({ path: `/monthly-plan/productionDemandPage/${this.selectedRows[0].monthPlanName}/${this.selectedRows[0].monthPlanVersion}/${this.selectedRows[0].id}` })
        },
        handleDel (record) {
          const self = this
          this.$confirm({
            title: '提示',
            content: '你确定删除该记录吗？',
            okText: '确定',
            okType: 'danger',
            cancelText: '取消',
            onOk () {
              self.deleteShipmentForecast(record)
            },
            onCancel () {
            }
          });
        },
        handleClose (record) {
          this.$confirm({
            title: '提示',
            content: '你确定关闭该记录吗？',
            okText: '确定',
            okType: 'danger',
            cancelText: '取消',
            onOk: () => {
              this.closeShipmentForecast(record)
            },
            onCancel () {
            }
          });
        },
        handleGoStatus (record) {
          this.$router.push({ path: `/shipmentForecastManagement/runningStatus/${record.id}` })
        },
        deleteShipmentForecast (record) {
        ApiDeleteScpMpsPlans(record.id).then((response) => {
            if (response.code === 200) {
              this.$message.success('删除成功')
              this.onSearch()
            } else {
              this.$message.error(response.msg)
            }
          })
        },
        closeShipmentForecast (record) {
          ApiCloseScpMpsPlans(record.id).then((response) => {
            if (response.code === 200) {
              this.$message.success('关闭成功')
              this.onSearch()
            } else {
              this.$message.error(response.msg)
            }
          })
        },
        sendShipmentForecast (record) {
          ApiSendSopMonthPlan({ id: record.id }).then((response) => {
            if (response.code === 200) {
              this.$message.success('发布成功')
              this.onSearch()
            } else {
              this.$message.error(response.msg)
            }
          })
        },
        handleGoDetail (record) {
          console.log(record);
          this.$router.push({ path: `/mps-work-desk/detail/${record.id}` })
        },
        handleEdit (record) {
          if (this.currentId && record.id !== this.currentId && this.isEdit) {
                this.$message.warning('请保存上次编辑的数据')
                return;
              }
              this.isEdit = true;
              this.currentId = record.id;
        },
        handleAdd () {
          this.$router.push({ path: `/monthly-plan/editPage/` })
        },
        /** 行选中 */
        selectedRowChange (selectedRowKeys, selectedRows) {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        // 表单搜索
        onSearch () {
          this.isEdit = false
          this.$refs.dataTable.searchParams = this.queryParams
          this.$refs.dataTable.getData()
        },
        // 编辑-保存
        handleSave (record) {
          // if (!record.conversionRate || Number(record.conversionRate) <= 0) {
          //   this.$message.warning('折换不能为空且需大于0')
          //   return
          // }
           ApiUpdateSopMonthPlan(record).then(response => {
              if (response.code === 200) {
                this.$message.success('保存成功')
                this.onSearch()
              } else {
                this.$message.error(response.msg)
              }
            })
        },
        // 取消
        handleCancel (record) {
          this.isEdit = false
          this.onSearch()
        },
        statusOnChange (record) {
          record.netSubInventory = record.netSubInventory === 'Y' ? 'N' : 'Y'
        },
        getLookupList (type, arr) {
          const lookupQueryParams = {
            lookupType: type,
            current: 1,
            pageSize: 100
          }
          this.getLookupListData(lookupQueryParams).then().then(response => {
            this[arr] = response.rows
            if (type === 'SCP_PROCESS_STATUS') {
              const filteredArray = response.rows.filter(function (obj) {
                  return obj.attribute3 === "Y";
                  });
                  this[arr] = filteredArray
          }
          })
        },
        handlePublish (record) {
          this.$confirm({
            title: '提示',
            content: '你确定发布该记录吗？',
            okText: '确定',
            okType: 'danger',
            cancelText: '取消',
            onOk: () => {
              ApiPublishScpMpsPlans(record.id).then(res => {
                if (res.code === 200) {
                  this.$message.success('发布成功')
                  this.onSearch()
                } else {
                  this.$message.error(res.msg)
                }
              })
            },
            onCancel () {
            }
          });
        }
      }
    }
    </script>

   <style scoped lang="less">
    .ml10 {
      margin-left: 10px;
    }/deep/.ant-select{
    width: 150px;
  }
    </style>
